/**
 * Created by suxiong on 2017/9/3.
 */
import $ from 'jquery'

export const baseURL = 'http://visitor.oriot.cn:9095/api/'

const requestHeader = function (request) {
//   request.setRequestHeader('Token', '')
//   request.setRequestHeader('SessionID', '')
}

export const get = (url) => {
  return $.ajax({
    url: baseURL + url,
    dataType: 'json',
    type: 'GET',
    contentType: 'application/json;charset=UTF-8',
    beforeSend: function (request) {
      requestHeader(request)
    },
    complete: function () {

    },
    error: function () {
    }
  })
}

export const post = function (url, data) {
  return $.ajax({
    url: baseURL +  url,
    dataType: 'jsonp',
    // dataType: 'json',
    type: 'POST',    
    xhrFields: {
        withCredentials: true // 这里设置了withCredentials
    },    
    contentType: 'application/json;charset=UTF-8',
    data: JSON.stringify(data),
    beforeSend: function (request) {
      requestHeader(request)
    },
    complete: function () {
    },
    error: function () {
    }
  })
}



// WEBPACK FOOTER //
// ./src/untils/ajax.js